export type AtLeast<T, K extends keyof T> = Partial<T> & Pick<T, K>;
export type Primitive = boolean | null | number | string | undefined;
export type ValueOf<T> = T[keyof T];
export enum ModalStatus {
  SUCCESS = "SUCCESS",
  FAIL = "FAIL",
  INFO = "INFO",
}
